import { ToolsRoutes } from "./names";

import type { AppRouteRecordRaw } from "@/app/router/types/types";

// A single page, not a group: a leaf route with `title` and `menuIcon` is a plain menu item.
// With no `menuOrder` it keeps the order of `toolsRoutes`, so it sits after Competitors. The
// tabs are not routes: the page switches them through the `#tab-<id>` hash (see `VTabs`).
export const forecastingRoutes: AppRouteRecordRaw[] = [
  {
    path: "forecasting",
    name: ToolsRoutes.FORECASTING,
    component: () => import("../../pages/forecasting/ForecastingPage.vue"),
    meta: {
      title: "Forecasting",
      pageKey: "ToolsForecasting",
      menuIcon: "lucide:bar-chart-2",
    },
  },
];
